import Main from './components/landing/main';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TermsAndConditions from "./components/legal/terms/terms"
import Students from "./components/target_users/students/students"
import Colleges from "./components/target_users/colleges/colleges"
import Customer from "./components/customer_stories/main"
import AboutUs from "./components/about_us/about_us"
import Products from "./components/products"
import Blogs from "./components/blog/blog"
import BlogView from './components/blog/blog_pages/blogView';

import PrivacyPolicy from './components/legal/privacy/privacy';
import Whitepaper from './components/whitepaper/whitepaper';
import Contact from './components/contact/contact';
import Blog1 from './components/blog/blog_pages/blog1';
import Blog2 from './components/blog/blog_pages/blog2';
import Blog3 from './components/blog/blog_pages/blog3';
import Blog4 from './components/blog/blog_pages/blog4';
import Blog5 from './components/blog/blog_pages/blog5';
import Blog6 from './components/blog/blog_pages/blog6';
import Blog7 from './components/blog/blog_pages/blog7';
import Blog8 from './components/blog/blog_pages/blog8';
import Blog9 from './components/blog/blog_pages/blog9';
import Blog10 from './components/blog/blog_pages/blog10';
import Blog11 from './components/blog/blog_pages/blog11';
import Blog12 from './components/blog/blog_pages/blog12';
import Blog13 from './components/blog/blog_pages/blog13';
import Blog14 from './components/blog/blog_pages/blog14';
import Blog15 from './components/blog/blog_pages/blog15';
import Blog16 from './components/blog/blog_pages/blog16';
import Blog17 from './components/blog/blog_pages/blog17';
import Blog18 from './components/blog/blog_pages/blog18';
import Blog19 from './components/blog/blog_pages/blog19';
import Blog20 from './components/blog/blog_pages/blog20';
import Blog21 from './components/blog/blog_pages/blog21';
import NotFound from './NotFound';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/products/:slug" element={<Products />} />
          <Route path="/students" element={<Students />} />
          <Route path="/colleges" element={<Colleges />} />
          <Route path="/customer_stories" element={<Customer />} />
          <Route path="/resources/about_us" element={<AboutUs />} />

          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:type" element={<Blogs />} />
          <Route path="/blogs/:type/:blogId" element={<BlogView />} />
              <Route path="/blogs/blog1" element={<Blog1 />} />
              <Route path="/blogs/blog2" element={<Blog2 />} />
              <Route path="/blogs/blog3" element={<Blog3 />} />
              <Route path="/blogs/blog4" element={<Blog4 />} />
              <Route path="/blogs/blog5" element={<Blog5 />} />
              <Route path="/blogs/blog6" element={<Blog6 />} />
              <Route path="/blogs/blog7" element={<Blog7 />} />
              <Route path="/blogs/blog8" element={<Blog8 />} /> 
              <Route path="/blogs/blog9" element={<Blog9 />} /> 
              <Route path="/blogs/blog10" element={<Blog10 />} /> 
              <Route path="/blogs/blog11" element={<Blog11 />} /> 
              <Route path="/blogs/blog12" element={<Blog12 />} /> 
              <Route path="/blogs/blog13" element={<Blog13 />} /> 
              <Route path="/blogs/blog14" element={<Blog14 />} /> 
              <Route path="/blogs/blog15" element={<Blog15 />} /> 
              <Route path="/blogs/blog16" element={<Blog16 />} /> 
              <Route path="/blogs/blog17" element={<Blog17 />} /> 
              <Route path="/blogs/blog18" element={<Blog18 />} /> 
              <Route path="/blogs/blog19" element={<Blog19 />} /> 
              <Route path="/blogs/blog20" element={<Blog20 />} /> 
              <Route path="/blogs/blog21" element={<Blog21 />} /> 
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/resources/whitepaper" element={<Whitepaper />} />
          <Route path="/contact" element={<Contact />} />
          
        <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
